"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var hexToRgba = function hexToRgba(hexColor, opacity) {
  var rgbColor = {
    r: parseInt(hexColor.substring(1, 3), 16),
    g: parseInt(hexColor.substring(3, 5), 16),
    b: parseInt(hexColor.substring(5), 16)
  };

  if (!rgbColor) {
    return '';
  }

  var r = rgbColor.r,
      g = rgbColor.g,
      b = rgbColor.b;
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};

var _default = hexToRgba;
exports["default"] = _default;